module.exports = "https://assets.meiaentrada.org.br/static/media/meia-entrada-estudantil.ef7a86e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/meia-entrada-estudantil.png
// module id = 253
// module chunks = 0